import React, { useContext, useEffect, useState } from 'react'

/* package */
import { Grid, Box, Typography, makeStyles } from '@material-ui/core'
import { GlobalContext } from '../../lib-atomic-context'
import { Buttons } from '../../lib-atomic'
import { WindowSize } from '../../lib-atomic-functions'
import { ModPublicWrapp } from '../../lib-atomic-design-section'

/* package */
import { FormHook, LocalStorage } from '../../lib-atomic-functions'
/* container */
import LostCardContainer from '../../app-module-lostcard-container/default'
/* container */

import Spinner2 from '../../app-module-cms-section-page-spinner/default'
import CONFIG from '../config'
import DialogBox from '../../lib-atomic/dialog/dialogbox'
import { FetchContextApiV2 } from '../../lib-atomic-functions'
/* CONSTANTS */
const mediaPath = CONFIG.setup.assets.media
/* CONSTANTS */

const google_play = CONFIG.setup.assets.google_play
const app_store = CONFIG.setup.assets.app_store
const phone = CONFIG.setup.assets.phone

//TODO: move somewhere else
const googlePlayLink = 'https://google.com'
const appStoreLink = 'https://google.com'
const FREEZE = {
  url: CONFIG.endpoints.transfer.url,
  method: CONFIG.endpoints.transfer.method,
  headers: CONFIG.endpoints.transfer.headers,
  responseType: 'json',
}
const useStyles = makeStyles((theme) => ({
  downloadApp: {
    paddingRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(1),
      order: 2,
    },
  },
  downloadAppRightPadded: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(0),
    order: 2,
    margin: 'auto',
  },
  orangeText: {
    color: theme.palette.secondary.dark,
    fontWeight: 'bold',
  },
  phone: {
    width: 130,
    position: 'absolute',
    top: -80,
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))
const Default = (props) => {
  const { country, lang } = LocalStorage.getLS()
  const currentlanguage = LocalStorage.getLS().translation.json.lostcard
  const { token } = LocalStorage.getLS().login
  const { width, height } = WindowSize()
  const classes = useStyles()
  const [spin, setSpin] = useState(false)
  const [response, setresponse] = React.useState()
  const [open, setOpen] = useState(false)
  const [isresponse, setisresponse] = useState(false)
  /* state */
  const { bannerscontents, freeze } = useContext(GlobalContext)
  /* state */
  const imgToDisplay = bannerscontents.state.data.masterbannerscontents.filter(
    (page) => {
      return page.pageName === 'LostCard'
    }
  )[0]
  // TODO: change to subsquad banner image
  /* state */

  const [fetchLogonObj] = FetchContextApiV2(FREEZE)

  const fetchLogonExecute = async (body, newHeader) => {
    freeze.dispatch({
      type: freeze.actionTypes.FETCH_FREEZE,
      freeze: await fetchLogonObj({ body, newHeader }, freeze),
    })
  }
  const freezeResetExecute = () => {
    freeze.dispatch({
      type: freeze.actionTypes.RESET,
    })
  }
  useEffect(() => {
    if (freeze.state.data) {
      const { freezeobj } = freeze.state.data
      const { outComeCode, flActive } = freezeobj

      if (outComeCode == 0) {
        setSpin(false)
        setOpen(true)
        var message = {
          outComeCode: '0',
          title: '',
          outComeMessage: currentlanguage.psge_lost_popup_success,
        }
        setresponse(message)
        setisresponse(true)
        freezeResetExecute()
      } else {
        setSpin(false)
        setOpen(true)
        var message = {
          outComeCode: '0',
          title: '',
          outComeMessage: currentlanguage.psge_lost_popup_error,
        }
        setresponse(message)

        setisresponse(true)
        freezeResetExecute()
      }
    }
  }, [freeze.state])
  // useEffect(() => {
  //   console.log(errorMessagePrepared)
  //   notmatchLogin = { error: [errorMessagePrepared] }
  // }, [errorMessagePrepared])

  const handleClose = (value) => {
    setOpen(false)
  }

  const handleSubmit = async () => {
    setSpin(true)
    const body = {}
    var newHeader = {
      Authorization: token,
    }

    // if (verified) {
    await fetchLogonExecute(body, newHeader)
    // }
  }

  const submitButton = {
    fullWidth: true,
    onClick: handleSubmit.bind(this),
  }
  const transferBtn = {
    onClick: () => {
      props.history.push('/transfercard')
    },
  }
  return (
    <div>
      {spin && <Spinner2.Popup />}
      {isresponse && (
        <DialogBox selectedValue={response} open={open} onClose={handleClose} />
      )}
      <ModPublicWrapp {...props} imgToDisplay={imgToDisplay}>
        <Grid
          // component={Box}
          container
          xs={12}
          sm={10}
          md={8}
          px={6}
          mx="auto"
          style={{ margin: 'auto', textAlign: 'left', marginTop: '30px' }}
          paddingTop={5}
          paddingBottom={12}
        >
          <Typography className="subway-six-inch" style={{ fontSize: 25 }}>
            {currentlanguage.page_lost_title1}
          </Typography>

          <Typography className="subway-six-inch" variant="body2" paragraph>
            {currentlanguage.page_lost_para1}
          </Typography>

          <Typography className="subway-six-inch" variant="body2" paragraph>
            {currentlanguage.page_lost_para2}
          </Typography>

          <Typography className="subway-six-inch" variant="body2" paragraph>
            {currentlanguage.page_lost_para3}
          </Typography>

          <Typography className="subway-six-inch" variant="body2" paragraph>
            {currentlanguage.page_lost_para4}
          </Typography>

          <Typography
            variant="body2"
            paragraph
            className="subway-six-inch"
            style={{ color: '#f15c22' }}
          >
            {currentlanguage.page_lost_para5}
          </Typography>
          <div
            style={{
              display: width < 450 ? 'block' : 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: 'auto',
              width: '90%',
              marginTop: 50,
            }}
          >
            <Buttons.Normal fullWidth {...submitButton}>
              {currentlanguage.page_lost_freeze_button}
            </Buttons.Normal>
            <div
              style={{
                marginLeft: 10,
                marginRight: 10,
                marginTop: 10,
                marginBottom: 10,
              }}
            />
            <Buttons.Normal fullWidth {...transferBtn}>
              {currentlanguage.page_lost_transfer_button}
            </Buttons.Normal>
          </div>
        </Grid>
      </ModPublicWrapp>
      <Grid
        style={{
          width: '100%',
          backgroundColor: '#f0f6f1',
          marginTop: 100,
          paddingTop: 20,
          paddingBottom: 60,
        }}
        // component={Box}
        // item
      >
        <Grid component={Box} container xs={12} sm={10} md={6} px={5} mx="auto">
          <Grid
            component={Box}
            item
            xs={12}
            sm={8}
            md={8}
            className={
              width < 960 ? classes.downloadAppRightPadded : classes.downloadApp
            }
          >
            <Typography
              variant="h5"
              gutterBottom
              className="subway-six-inch"
              style={{
                color: '#f15c22',
                alignSelf: 'center',
              }}
            >
              {currentlanguage.page_lost_footer_para1}
            </Typography>

            <Typography variant="body2" paragraph className="subway-six-inch">
              {currentlanguage.page_lost_footer_para2}
            </Typography>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: 'auto',
                width: '90%',
              }}
            >
              <Box alignItems="center" my={3}>
                <a
                  href={currentlanguage.page_lost_google_play_icon_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={currentlanguage.page_lost_google_play_icon}
                    alt="Google Play"
                    width="100%"
                    maxWidth="90"
                  />
                </a>
              </Box>
              <div
                style={{
                  marginLeft:
                    width < 450
                      ? 10
                      : width < 600
                      ? 30
                      : width > 860 && width < 960
                      ? 30
                      : 10,
                  marginRight:
                    width < 450
                      ? 10
                      : width < 600
                      ? 30
                      : width > 860 && width < 960
                      ? 30
                      : 10,
                }}
              />
              <Box alignItems="center" my={3}>
                <a
                  href={currentlanguage.page_lost_apple_store_icon_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={currentlanguage.page_lost_apple_store_icon}
                    alt="App Store"
                    width="100%"
                    maxWidth="150"
                  />
                </a>
              </Box>
            </div>
          </Grid>

          <Grid
            container
            item
            xs={12}
            md={4}
            style={{ position: 'relative' }}
            component={Box}
            height={320}
          >
            <img src={phone} alt="phone" className={classes.phone} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default Default
